var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      _vm._m(0),
      _c("p", { staticClass: "text-muted mb-4" }, [
        _vm._v(
          " Informe os dados econômicos e operacionais da entidade para análise do credenciamento. "
        )
      ]),
      _c(
        "b-alert",
        { staticClass: "mt-4", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("h6", { staticClass: "alert-heading" }, [
              _c("i", { staticClass: "feather icon-info mr-1" }),
              _vm._v(" Informações Importantes ")
            ]),
            _c("hr"),
            _c("ul", { staticClass: "mb-0" }, [
              _c("li", [
                _c("strong", [_vm._v("Período de Referência:")]),
                _vm._v(
                  " Deve corresponder ao período de vigência do certificado"
                )
              ]),
              _c("li", [
                _c("strong", [_vm._v("Bolsas:")]),
                _vm._v(
                  " Considere apenas bolsas de estudo regulares oferecidas pela entidade"
                )
              ]),
              _c("li", [
                _c("strong", [_vm._v("Tipos de Bolsas:")]),
                _vm._v(" Integral (100%) e/ou Parcial (percentual variável)")
              ])
            ])
          ])
        ]
      ),
      _c("h6", { staticClass: "mt-4 mb-3 text-muted" }, [
        _vm._v("Período de Referência do Certificado")
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Data de Início",
                    "label-class": "required",
                    "label-for": "certificatePeriodStart"
                  }
                },
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      id: "certificatePeriodStart",
                      value: _vm.formData.certificate_period_start,
                      placeholder: "Selecione a data de início",
                      state: _vm.getFieldState("certificate_period_start"),
                      disabled: _vm.disabled,
                      locale: "pt-BR",
                      "date-format-options": {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit"
                      }
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "certificate_period_start",
                          $event
                        )
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-calendar mr-1" }),
                    _vm._v(" Data de início do período do certificado ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Data de início do período é obrigatória ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Data de Fim",
                    "label-class": "required",
                    "label-for": "certificatePeriodEnd"
                  }
                },
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      id: "certificatePeriodEnd",
                      value: _vm.formData.certificate_period_end,
                      placeholder: "Selecione a data de fim",
                      state: _vm.getFieldState("certificate_period_end"),
                      disabled: _vm.disabled,
                      locale: "pt-BR",
                      "date-format-options": {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit"
                      },
                      min: _vm.formData.certificate_period_start
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("certificate_period_end", $event)
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-calendar mr-1" }),
                    _vm._v(
                      " A data de fim deve ser posterior à data de início "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Data de fim do período é obrigatória ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h6", { staticClass: "mt-4 mb-3 text-muted" }, [
        _vm._v("Informações sobre Bolsas de Estudo")
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Número de Bolsas Ofertadas",
                    "label-class": "required",
                    "label-for": "scholarshipCount"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "scholarshipCount",
                      value: _vm.formData.scholarship_count,
                      type: "number",
                      min: "0",
                      placeholder: "Digite o número de bolsas",
                      state: _vm.getFieldState("scholarship_count"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("scholarship_count", $event)
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-award mr-1" }),
                    _vm._v(
                      " Total de bolsas de estudo oferecidas pela entidade "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Número de bolsas é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: { label: "Tipos de Bolsas", "label-class": "required" }
                },
                [
                  _c("b-form-checkbox-group", {
                    class: !_vm.primaryVariant
                      ? "checkbox-dynamic-primary"
                      : "",
                    attrs: {
                      options: _vm.scholarshipTypeOptions,
                      state: _vm.getFieldState("scholarship_types"),
                      disabled: _vm.disabled,
                      stacked: ""
                    },
                    on: { change: _vm.handleScholarshipTypesChange },
                    model: {
                      value: _vm.selectedTypes,
                      callback: function($$v) {
                        _vm.selectedTypes = $$v
                      },
                      expression: "selectedTypes"
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-check-square mr-1" }),
                    _vm._v(
                      " Selecione todos os tipos de bolsas oferecidas pela entidade "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Selecione pelo menos um tipo de bolsa ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Serviços de Apoio aos Bolsistas",
                    "label-for": "supportServices"
                  }
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "supportServices",
                      value: _vm.formData.support_services,
                      placeholder:
                        "Descreva os serviços de apoio oferecidos aos bolsistas (opcional)",
                      rows: "4",
                      state: _vm.getFieldState("support_services"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("support_services", $event)
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-users mr-1" }),
                    _vm._v(
                      " Descreva programas de tutoria, apoio psicopedagógico, atividades complementares, etc. (Campo opcional) "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Erro na descrição dos serviços de apoio ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h6", { staticClass: "mt-4 mb-3 text-muted" }, [
        _vm._v("Documentação")
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Relatório de Atividades Desempenhadas",
                    "label-class": "required",
                    "label-for": "reportActivities"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "reportActivities",
                      value: _vm.formData.report_activities
                        ? _vm.formData.report_activities.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("report_activities"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("report_activities", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.report_activities
                    ? [
                        _vm.formData.report_activities.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.report_activities.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Relatório de atividades é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Relatório Sintético de Concessão de Bolsas",
                    "label-class": "required",
                    "label-for": "summaryReportScholarships"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "summaryReportScholarships",
                      value: _vm.formData.summary_report_scholarships
                        ? _vm.formData.summary_report_scholarships.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("summary_report_scholarships"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "summary_report_scholarships",
                          $event
                        )
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.summary_report_scholarships
                    ? [
                        _vm.formData.summary_report_scholarships.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.summary_report_scholarships.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Relatório sintético de bolsas é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Relação de Bolsas de Estudo",
                    "label-class": "required",
                    "label-for": "listScholarships"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "listScholarships",
                      value: _vm.formData.list_scholarships
                        ? _vm.formData.list_scholarships.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("list_scholarships"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("list_scholarships", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.list_scholarships
                    ? [
                        _vm.formData.list_scholarships.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.list_scholarships.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Relação de bolsas de estudo é obrigatória ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label:
                      "Análise do Perfil Socioeconômico dos Alunos Bolsistas",
                    "label-class": "required",
                    "label-for": "analysisSocioeconomicStudents"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "analysisSocioeconomicStudents",
                      value: _vm.formData.analysis_socioeconomic_students
                        ? _vm.formData.analysis_socioeconomic_students.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState(
                        "analysis_socioeconomic_students"
                      ),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "analysis_socioeconomic_students",
                          $event
                        )
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.analysis_socioeconomic_students
                    ? [
                        _vm.formData.analysis_socioeconomic_students.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.analysis_socioeconomic_students.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Análise do perfil socioeconômico é obrigatória ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Regime Contábil",
                    "label-class": "required",
                    "label-for": "accountingRegime"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "accountingRegime",
                      value: _vm.formData.accounting_regime
                        ? _vm.formData.accounting_regime.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("accounting_regime"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("accounting_regime", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.accounting_regime
                    ? [
                        _vm.formData.accounting_regime.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.accounting_regime.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Regime contábil é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Relatórios Contábeis",
                    "label-class": "required",
                    "label-for": "accountingReports"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "accountingReports",
                      value: _vm.formData.accounting_reports
                        ? _vm.formData.accounting_reports.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("accounting_reports"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("accounting_reports", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.accounting_reports
                    ? [
                        _vm.formData.accounting_reports.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.accounting_reports.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Relatórios contábeis são obrigatórios ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Demonstração Contábil da Gratuidade",
                    "label-class": "required",
                    "label-for": "accountingGratuityDemo"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "accountingGratuityDemo",
                      value: _vm.formData.accounting_gratuity_demo
                        ? _vm.formData.accounting_gratuity_demo.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("accounting_gratuity_demo"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "accounting_gratuity_demo",
                          $event
                        )
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.accounting_gratuity_demo
                    ? [
                        _vm.formData.accounting_gratuity_demo.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.accounting_gratuity_demo.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " Demonstração contábil da gratuidade é obrigatória "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label:
                      "Parecer de Auditoria Independente do Exercício em Análise",
                    "label-class": "required",
                    "label-for": "auditOpinion"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "auditOpinion",
                      value: _vm.formData.audit_opinion
                        ? _vm.formData.audit_opinion.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("audit_opinion"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("audit_opinion", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.audit_opinion
                    ? [
                        _vm.formData.audit_opinion.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.audit_opinion.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Parecer de auditoria independente é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Receita Efetivamente Recebida",
                    "label-class": "required",
                    "label-for": "revenueReceived"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "revenueReceived",
                      value: _vm.formData.revenue_received
                        ? _vm.formData.revenue_received.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("revenue_received"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("revenue_received", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.revenue_received
                    ? [
                        _vm.formData.revenue_received.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.revenue_received.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Receita efetivamente recebida é obrigatória ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Plano de Atendimento",
                    "label-class": "required",
                    "label-for": "servicePlan"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "servicePlan",
                      value: _vm.formData.service_plan
                        ? _vm.formData.service_plan.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("service_plan"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("service_plan", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.service_plan
                    ? [
                        _vm.formData.service_plan.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.service_plan.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(" Apenas arquivos PDF. Tamanho máximo: 10MB ")
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Plano de atendimento é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Inscrição dos Serviços Socioassistenciais",
                    "label-for": "socialAssistanceRegistration"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "socialAssistanceRegistration",
                      value: _vm.formData.social_assistance_registration
                        ? _vm.formData.social_assistance_registration.file
                        : null,
                      placeholder:
                        "Clique para selecionar o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState(
                        "social_assistance_registration"
                      ),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "social_assistance_registration",
                          $event
                        )
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.social_assistance_registration
                    ? [
                        _vm.formData.social_assistance_registration.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.social_assistance_registration.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-file-text mr-1" }),
                    _vm._v(
                      " Apenas arquivos PDF. Tamanho máximo: 10MB. Campo opcional. "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.hasUploadedFiles
        ? _c(
            "div",
            { staticClass: "uploaded-files mt-4" },
            [
              _vm._m(1),
              _c(
                "b-card",
                [
                  _c(
                    "b-list-group",
                    _vm._l(_vm.uploadedFiles, function(file, key) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: key,
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "feather icon-file-text text-danger mr-2"
                            }),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getDocumentTitle(key)))
                            ]),
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm.getDocumentUrl(_vm.uploadedFiles[key])
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "mr-1 no-print download-link text-primary",
                                      attrs: {
                                        href: _vm.getDocumentUrl(
                                          _vm.uploadedFiles[key]
                                        ),
                                        target: "_blank",
                                        title: "Baixar arquivo"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "feather icon-download"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.getFileName(key)) + " "),
                              _c("small", { staticClass: "ml-2" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.formatFileSize(_vm.getFileSize(key))
                                    ) +
                                    ")"
                                )
                              ]),
                              _c("small", { staticClass: "ml-2 text-muted" }, [
                                _vm._v(
                                  "[" +
                                    _vm._s(
                                      _vm.getFileExtension(_vm.getFileName(key))
                                    ) +
                                    "]"
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "feather icon-bar-chart mr-2" }),
      _vm._v(" Dados Econômicos e Operacionais ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "text-muted mb-3" }, [
      _c("i", { staticClass: "feather icon-check-circle mr-1" }),
      _vm._v(" Arquivos Carregados ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }